import { debounce } from 'lodash-es';
import { connect } from 'react-redux';

import { FilterMode } from 'src/sections/repository/sections/source/constants';
import { getCurrentRepositoryMainBranchName } from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';

import {
  filterFiles,
  onCodeSearchChange,
  onFilterModeChange,
} from '../actions/filter-files';
import DirectoryPathFilter from '../components/directory-path-filter';
import { getFilteredFiles, getFilterQuery } from '../reducers/section';

const FILTER_DEBOUNCE = 100;
const SEARCH_DEBOUNCE = 400;

const mapStateToProps = (state: BucketState) => {
  const query = getFilterQuery(state);
  const filteredFiles = getFilteredFiles(state);
  const currentBranchName = state.repository.source.section.ref?.name;
  const mainBranchName = getCurrentRepositoryMainBranchName(state);

  return {
    isFiltering: query || !!filteredFiles,
    isMainBranch: currentBranchName === mainBranchName,
  };
};

const getDebouncedDispatch = (delay: number) =>
  debounce((dispatch, action) => {
    dispatch(action);
  }, delay);
const debouncedDispatchFilter = getDebouncedDispatch(FILTER_DEBOUNCE);
const debouncedDispatchSearch = getDebouncedDispatch(SEARCH_DEBOUNCE);

// @ts-ignore TODO: fix noImplicitAny error here
const mapDispatchToProps = dispatch => ({
  // @ts-ignore TODO: fix noImplicitAny error here
  onFilterChange: query => {
    const action = filterFiles(query);
    // Need to debounce here, because when the user clears the field using the “Backspace” button at a fast pace,
    // the default search view does not appear (because of the debounceDispatch below).
    if (!query) {
      return debouncedDispatchFilter(dispatch, filterFiles(''));
    }
    return debouncedDispatchFilter(dispatch, action);
  },
  onCodeSearchChange: (query: string) => {
    const action = onCodeSearchChange(query);
    return debouncedDispatchSearch(dispatch, action);
  },
  onClearFilter: () => dispatch(filterFiles('')),
  onFilterModeChange: (filterMode: FilterMode) =>
    dispatch(onFilterModeChange(filterMode)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DirectoryPathFilter);
